<template>
  <div class="locationError">
    <div class="locationError_text">{{message}}</div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: ['errorCode'],
  computed: {
    message: function() {
      const errorMessage = {
      		0: "原因不明のエラーが発生しました…。",
      		1: "位置情報の取得を許可してください",
      		2: "電波状況などで位置情報が取得できませんでした" ,
      		3: "タイムアウトしました",
    	}
      return errorMessage[this.errorCode]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/locationError.vue